import axios from 'axios'
import { clearAuthTokens, saveAuthTokens } from '../lib/helpers/authStorage'
import { isTokenAvailable } from '../lib/helpers/tokenAvailability'
import { USER_TOKEN_KEY, USER_REFRESH_TOKEN_KEY } from '../lib/const/localstorage'

const $api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: false
})

$api.interceptors.request.use((config) => {
    if (isTokenAvailable()) {
        config.headers.Authorization = `Bearer ${localStorage.getItem(USER_TOKEN_KEY)}`
    }
    return config
})

const refreshAccessToken = async (): Promise<string | null> => {
    const refresh_token = localStorage.getItem(USER_REFRESH_TOKEN_KEY)

    if (!refresh_token) {
        clearAuthTokens()
        return null
    }

    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/auth/refresh`,
            { refresh_token }
        )

        const { access_token, refresh_token: newRefreshToken } = response.data
        saveAuthTokens(access_token, newRefreshToken)

        return access_token
    } catch {
        clearAuthTokens()
        return null
    }
}

$api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config

        if (
            error.response?.status === 401 &&
            originalRequest &&
            !originalRequest._retry &&
            !originalRequest.url?.includes('/auth/refresh') &&
            !originalRequest.url?.includes('/auth/login')
        ) {
            originalRequest._retry = true
            const newAccessToken = await refreshAccessToken()

            if (newAccessToken) {
                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`
                return $api(originalRequest)
            }
        }

        return Promise.reject(error)
    }
)

export default $api
